"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var formik_1 = require("formik");
var lodash_get_1 = __importDefault(require("lodash.get"));
var __1 = __importDefault(require("../.."));
var Button_1 = __importDefault(require("../../../../basics/Button"));
var Legend_1 = __importDefault(require("../Legend"));
var Rows_1 = __importDefault(require("../Rows"));
function Repeatable(_a) {
    var name = _a.name, label = _a.label, defaultValue = _a.defaultValue, children = _a.children, _b = _a.required, required = _b === void 0 ? true : _b, _c = _a.allowNew, allowNew = _c === void 0 ? true : _c;
    var formik = formik_1.useFormikContext();
    var value = lodash_get_1.default(formik.values, name);
    var items = Array.isArray(value) ? value : [value];
    return (react_1.default.createElement(Legend_1.default, { "data-component-name": "Form.Repeatable", id: formik.values.__name + "_" + name, label: label && required ? label + " *" : label },
        react_1.default.createElement(formik_1.FieldArray, { name: name }, function (_a) {
            var remove = _a.remove, push = _a.push;
            return (react_1.default.createElement(Rows_1.default, null,
                items.map(function (item, index) { return (react_1.default.createElement(Legend_1.default, { id: formik.values.__name + "_" + index, key: index, label: label ? label + " #" + (index + 1) : "#" + (index + 1) },
                    react_1.default.createElement(__1.default.Rows, { split: { small: [80, 20], medium: [80, 20], large: [80, 20] } },
                        react_1.default.createElement("div", null, children({ name: name + "." + index, value: item })),
                        react_1.default.createElement(Button_1.default, { version: "outline", type: "button", onClick: function () { return remove(index); } }, "Remove")))); }),
                allowNew && (react_1.default.createElement(Button_1.default, { level: "2", version: "outline", type: "button", onClick: function () { return push(defaultValue); }, fullWidth: true }, "Add"))));
        })));
}
exports.default = Repeatable;
